module.exports = __webpack_public_path__ + "static/media/2020-05-15 to-a-new-start.cff98116.md";